/**
 * Broker announcements admin client (DEV-3636, Skynet.Loans behind the loans
 * gateway). Internal-staff CRUD over the announcements brokers see — list
 * (including inactive/expired), create, update, and soft-delete.
 *
 * Gated on the commandCenter.manageAnnouncements claim server-side: these endpoints
 * 403 until that claim-seed deploys, so callers must degrade gracefully.
 *
 * List response shape:
 *   { announcements: [{ id, companyId, subCompanyId, title, body, severity,
 *     effectiveFrom, expiresAt, isActive, createdByUserId, createdAt, updatedAt }] }
 */
export class BrokerAnnouncementsAdminApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAnnouncements({ companyId, subCompanyId, config = {} } = {}) {
    return this.#http.get('/api/admin/command-center/announcements', {
      ...config,
      params: { companyId, subCompanyId },
    });
  }

  async createAnnouncement(body) {
    return this.#http.post('/api/admin/command-center/announcements', body);
  }

  async updateAnnouncement({ id, ...body }) {
    return this.#http.put(`/api/admin/command-center/announcements/${id}`, body);
  }

  async deleteAnnouncement(id) {
    return this.#http.delete(`/api/admin/command-center/announcements/${id}`);
  }
}
